import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useDispatch, useSelector } from 'react-redux';

import { openAeroPhotoModal } from '../../actions/aeroPhotoTour';
import { AeroPhotoTourEntry } from '../../components/AeroPhotoTourEntry';
import { getAeroPhotoTourBackground, getIsAeroPhotoTourAvailable } from '../../selectors/aeroPhotoTour';
import { isWebglSupported } from './helpers';
import { trackClickAeroPhoto, trackShowAeroPhoto } from './tracking';

export const AeroPhotoTourEntryContainer = () => {
  const [isSupported, setIsSupported] = React.useState(false);

  const background = useSelector(getAeroPhotoTourBackground);
  const isAvailable = useSelector(getIsAeroPhotoTourAvailable);
  const dispatch = useDispatch();

  const handleEntryClick = React.useCallback(() => {
    dispatch(openAeroPhotoModal());
    trackClickAeroPhoto();
  }, [dispatch]);

  React.useEffect(() => {
    setIsSupported(isWebglSupported());
  }, []);

  if (!isAvailable || !isSupported) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackShowAeroPhoto} triggerOnce={false}>
      <AeroPhotoTourEntry background={background} onClick={handleEntryClick} />
    </ActionAfterViewObserver>
  );
};
